import http from './api'
import type { AdminMatchListItem, AdminMatchListResponse } from './matchService'

export type { AdminMatchListItem, AdminMatchListResponse }

export interface AdminMatchListParams {
  search?: string
  league?: string
  dateFrom?: string
  dateTo?: string
  page?: number
  limit?: number
  futureOnly?: boolean
  playedOnly?: boolean
}

export interface AdminMatchWritePayload {
  index?: string
  number?: string | null
  date?: string
  time?: string
  teamA: string
  teamB: string
  league: string
  score?: string | null
  winner?: string | null
  playoff?: boolean
  playoffUniqueGame?: boolean
  firstLegMatchScore?: string | null
  winnerAdditionalTime?: string | null
  winnerPenalties?: string | null
}

export interface AdminMatchCreatePayload extends AdminMatchWritePayload {
  index: string
  date: string
  time: string
}

function serializeAdminMatchListParams(params?: AdminMatchListParams): Record<string, string | number> {
  const query: Record<string, string | number> = {}
  if (!params) return query
  if (params.search) query.search = params.search
  if (params.league) query.league = params.league
  if (params.dateFrom) query.dateFrom = params.dateFrom
  if (params.dateTo) query.dateTo = params.dateTo
  if (params.page != null) query.page = params.page
  if (params.limit != null) query.limit = params.limit
  if (params.futureOnly) query.futureOnly = 'true'
  if (params.playedOnly) query.playedOnly = 'true'
  return query
}

class AdminMatchesService {
  async list(params?: AdminMatchListParams): Promise<AdminMatchListResponse> {
    const response = await http.get<AdminMatchListResponse>('/admin/matches', {
      params: serializeAdminMatchListParams(params),
    })
    return response.data
  }

  async getOne(id: string): Promise<AdminMatchListItem> {
    const response = await http.get<AdminMatchListItem>(`/admin/matches/${id}`)
    return response.data
  }

  async create(data: AdminMatchCreatePayload): Promise<AdminMatchListItem> {
    const response = await http.post<AdminMatchListItem>('/admin/matches', data)
    return response.data
  }

  async update(id: string, data: AdminMatchWritePayload): Promise<AdminMatchListItem> {
    const response = await http.patch<AdminMatchListItem>(`/admin/matches/${id}`, data)
    return response.data
  }

  async remove(id: string): Promise<{ ok: boolean; id: string }> {
    const response = await http.delete<{ ok: boolean; id: string }>(`/admin/matches/${id}`)
    return response.data
  }
}

export default new AdminMatchesService()
